export enum UsageType {
  PROFILE = 'P',
  MESSAGE = 'M'
}
